import { any } from "bluebird";
import React from "react";
import {
    ButtonToolbar,
    Button,
    Modal,
    Form,
    FormGroup,
    ControlLabel,
    FormControl,
} from 'react-bootstrap';
import { BootstrapTable } from "react-bootstrap-table";
import DefineGroupPopup from "./DefineGroupPopUp";

class DefineGroups extends React.Component {
    constructor(props) {
        super(props);

    }
    render() {
        return (
            <div>
                <div className="instruction-outer-box" >
                    <div className="instruction-inner-box" >
                        A. Click Define Groups to setup and name your group or subgroups if you have more than one.<br></br>
                        B. In the room grid add room type (from dropdown menu,) and number of rooms per room type.<br></br>
                        C. Next, set up your hotel bid preferences for your group(s.) Choose bid questions and add bid notes. Please note, these will go to each hotel you request in each city.<br></br>
                        D. Save and Review
                    </div>
                </div>
                <DefineGroupPopup
                    tour={this.props.tour}
                    newGroup={this.props.newGroup}
                    removeGroup={this.props.removeGroup}
                    editGroup={this.props.editGroup}
                    createQuestions={this.props.createQuestions}
                    addedQuestion={this.props.addedQuestion}
                    addQuestion={this.props.addQuestion}
                    removeQuestion={this.props.removeQuestion}
                    requestTourquestions={this.props.requestTourquestions}
                    reloadmethod={this.reload}
                    newRoomType={this.props.newRoomType}
                    addMultipleBidDetail={this.props.addMultipleBidDetail}
                    saveRoomPreferences={this.props.saveRoomPreferences}
                />
            </div>
        )
    }

}

export default DefineGroups;



// WEBPACK FOOTER //
// src/routes/tours/components/DefineGroups.js